<template>
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none">
    <path
      d="M5.20069 12.6482L2 9.64819M2 9.64819L5.20069 6.64819M2 9.64819L16 9.64819"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
  export default {
    name: 'ArrowLeftIcon',
  };
</script>
